import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const LoanImagesList = () => {
  const [loans, setLoans] = useState([]);
  const [selectedLoanId, setSelectedLoanId] = useState("");
  const [images, setImages] = useState([]);
  const token = sessionStorage.getItem("authToken");

  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/allLoans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.loan || []);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  const fetchImages = async (loanId) => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getLoanImagesById/${loanId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setImages(res.data.images || []);
    } catch (error) {
      console.error("Error fetching loan images:", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;
    try {
      await axios.delete(`${COMMON_API}/loan/deleteLoanImages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchImages(selectedLoanId);
    } catch (error) {
      console.error("Error deleting loan image:", error);
    }
  };

  useEffect(() => {
    fetchLoans();
  }, []);

  useEffect(() => {
    if (selectedLoanId) fetchImages(selectedLoanId);
  }, [selectedLoanId]);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Loan Images</h2>

        <div className="mb-6">
          <label className="block text-gray-600 font-medium mb-1">Select Loan</label>
          <select
            value={selectedLoanId}
            onChange={(e) => setSelectedLoanId(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
          >
            <option value="">-- Select Loan --</option>
            {loans.map((loan) => (
              <option key={loan.id} value={loan.id}>
                {loan.name}
              </option>
            ))}
          </select>
        </div>

        {selectedLoanId && (
          <>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-gray-700">Images List</h3>
              <Link
                to="/add-loan-image"
                state={{ loan_id: selectedLoanId }}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                + Add Image
              </Link>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {images.map((img) => (
                <div
                  key={img.id}
                  className="border rounded-xl shadow-sm bg-gray-50 p-4 flex flex-col justify-between hover:shadow-md transition"
                >
                  <div>
                    <img
                      src={`${COMMON_API}/ImgUploads/${img.image}`}
                      alt="Loan"
                      className="w-full h-40 object-cover rounded-lg mb-3"
                    />
                    <p className="text-gray-600">
                      <strong>Position:</strong> {img.position}
                    </p>
                  </div>
                  <div className="flex gap-3 mt-4">
                    <Link
                      to={`/edit-loan-image/${img.id}`}
                      className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 transition"
                    >
                      Edit
                    </Link>
                    <button
                      className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
                      onClick={() => handleDelete(img.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
              {images.length === 0 && (
                <p className="text-gray-500 col-span-full text-center">No images found.</p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoanImagesList;
